import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  view: {
    flex: 1,
    flexDirection: "column",
    height: "100%",
    width: "100%",
    display: "flex",
  },
  body: {
    flexDirection: "row",
    display: "flex",
    flex: 1,
    height: "100vh",
  },
  content: {
    padding: "10px",
    width: "100%",
  },
}));

export default useStyles;
